export const SAVE_LEAD_SOURCE_LIST = 'SAVE_LEAD_SOURCE_LIST'; 
export const SAVE_LEAD_SOURCE_DETAILS = 'SAVE_LEAD_SOURCE_DETAILS';  